import React, { Component } from 'react';
import quizQuestions from './api/quizQuestions';
import Quiz from './components/Quiz';
import Result from './components/Result';
import logo from './svg/logo.svg';
import './App.css';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      counter: 0,
      questionId: 1,
      question: '',
      answerOptions: [],
      answer: '',
      answersCount: {},
      result: '',
      incorrectQuestions: [],
    };
    this.handleAnswerSelected = this.handleAnswerSelected.bind(this);
  }

  componentDidMount() {
    const shuffledAnswerOptions = quizQuestions.map(question =>
      this.shuffleArray(question.answers)
    );
    this.setState({
      question: quizQuestions[0].question,
      answerOptions: shuffledAnswerOptions[0]
    });
  }

  shuffleArray(array) {
    var currentIndex = array.length,
      temporaryValue,
      randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }

  handleAnswerSelected(event) {
    this.setUserAnswer(event.currentTarget.value);

    if (this.state.questionId < quizQuestions.length) {
      setTimeout(() => this.setNextQuestion(), 500);
    } else {
      setTimeout(() => this.setResults(this.getResults()), 500);
    }
  }

  setUserAnswer(answer) {

    if (answer === "incorrect") {

      this.setState((state, props) => ({
        answersCount: {
          ...state.answersCount,
          [answer]: (state.answersCount[answer] || 0) + 1
        },
          answer: answer,
          incorrectQuestions: state.incorrectQuestions.concat(state.questionId)
        }));
    }
    else {

      this.setState((state, props) => ({
        answersCount: {
          ...state.answersCount,
          [answer]: (state.answersCount[answer] || 0) + 1
        },
          answer: answer,
        }));
    }
  }

  setNextQuestion() {
    const counter = this.state.counter + 1;
    const questionId = this.state.questionId + 1;

    this.setState({
      counter: counter,
      questionId: questionId,
      question: quizQuestions[counter].question,
      answerOptions: quizQuestions[counter].answers,
      answer: ''
    });
  }

  getResults() {
    const answersCount = this.state.answersCount;
    const answersCountKeys = Object.keys(answersCount);
    const answersCountValues = answersCountKeys.map(key => answersCount[key]);
    const maxAnswerCount = Math.max.apply(null, answersCountValues);
    return answersCount;
  }

  setResults(result) {
    this.setState({ result: result.correct ? ((result.correct) + "/" + (this.state.counter + 1)) : "no questions" });
  }

  renderQuiz() {
    return (
      <Quiz
        answer={this.state.answer}
        answerOptions={this.state.answerOptions}
        questionId={this.state.questionId}
        question={this.state.question}
        questionTotal={quizQuestions.length}
        onAnswerSelected={this.handleAnswerSelected}
      />
    );
  }

  renderResult() {
    return <Result quizResult={this.state.result} 
                   wrong={this.state.incorrectQuestions} 
                   quizQuestions={quizQuestions}/>;
  }

  render() {
    return (
      <div className="App">
        <div className="App-header">
          
        <a href="https://magnify.michigandaily.us/election2020/" class="headerButton"><i class="fas fa-chevron-left"></i> &nbsp;Back to site</a>
        
          <a href="https://magnify.michigandaily.us/election2020/"><img src={logo} className="App-logo" alt="logo" /></a>
          <h2>Who said it: Trump, Biden, or Schlissel?</h2>
        </div>
        {this.state.result ? this.renderResult() : this.renderQuiz()}
        <div id="socialRow">
          <a href="https://www.facebook.com/sharer/sharer.php?u=https://magnify.michigandaily.us/election2020_whosaidit/" class="fa faSocial fa-facebook"></a>
          <a href="https://twitter.com/intent/tweet?url=https://magnify.michigandaily.us/election2020_whosaidit/" class="fa faSocial fa-twitter"></a>
        </div>
      </div>
    );
  }
}

export default App;
